<template>
  <div class='QA_con'>
    <div class='pub_top_block w_1200'>
      <dl>
        <dt>
          <h3>{{ $t('home.qa.info.title') }}</h3>
          <div class='text' v-html='$t("home.qa.detail.desc")'></div>
        </dt>
      </dl>
      <img src='' alt='' class='bg'>
    </div>
    <div class='item_box w_1200'>
      <ul class='fz_0'>
        <li v-for='item in qaList' :key='item.id' class='item' @click='getDetail(item.id)'>
          <div class='img_box' @click.stop='watchVideo(item)'>
            <img :src='item.image' alt=''>
            <i class='icon'></i>
          </div>
          <h3>{{ item.title }}</h3>
          <div class='date'>{{ item.date }}&nbsp;{{ item.viewTimes }}{{ $t("home.qa.detail.pv") }}</div>
          <div class='addit fz_0'>
            <span class='dis_ib ver_m'>{{ $t("home.qa.detail.more") }}</span>
            <i class='iconic_forward_right iconfont icon_enter_btn dis_ib ver_m'></i>
          </div>
        </li>
      </ul>
    </div>
    <!-- 简介 -->
    <div v-show='showDetail' class='dialog_box QA_info'>
      <div class='dialog'>
        <div class='icon_close_btn iconic_close iconfont' @click='close'></div>
        <dl class='fz_0'>
          <dt class='img_box dis_ib ver_t'><img :src='detailInfo.image' alt=''></dt>
          <dd class='dis_ib ver_t'>
            <h3>{{ detailInfo.title }}</h3>
            <div class='date'>{{ detailInfo.date }} {{ detailInfo.viewTimes }}次观看</div>
          </dd>
        </dl>
        <html-content class='info' :html='detailInfo.content'></html-content>
      </div>
    </div>
    <video-modal :show='showVideo'
                 :video-url='currVideoUrl'
                 :poster='currVideoImage'
                 @close='closeVideo'
    ></video-modal>
  </div>
</template>

<script>
import { setTitle, mediaDevice } from 'utils'
import { getQaTalkByPage, getQaDetail } from '@/service'
import VideoModal from '@/components/VideoModal'
import HtmlContent from '@/components/HtmlContent'

export default {
  name: 'QA',
  data () {
    return {
      showDetail: false,
      qaList: [],
      page: 1,
      detailInfo: {},
      showVideo: false,
      currVideoUrl: '',
      currVideoImage: '',
    }
  },
  components: {
    VideoModal,
    HtmlContent,
  },
  mounted () {
    setTitle(`${this.$t('home.logo')} - QA`)
    this.getQaByPage()
  },
  methods: {
    getQaByPage () {
      getQaTalkByPage({ page: this.page }).then(res => {
        this.qaList = res.data.items
      })
    },
    getDetail (id) {
      this.detailInfo = {}
      getQaDetail(id).then(res => {
        document.body.className = 'fixed'
        this.showDetail = true
        this.detailInfo = res.data
      })
    },
    close () {
      this.showDetail = false
      document.body.className = ''
    },
    watchVideo (item) {
      this.currVideoUrl = item.video
      this.currVideoImage = item.image
      this.showVideo = true
      setTimeout(() => {
        const ele = document.getElementById('video')
        if (mediaDevice() === 'mobile') {
          ele.requestFullscreen()
        }
        ele.play()
      }, 1000)
    },
    closeVideo () {
      this.showVideo = false
    },
  },
}
</script>
